import React, { useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTheme } from '../ThemeContext';
import { AuthContext } from '../App';
import SiteSwitcher from './SiteSwitcher';

export default function TopBar() {
  var navigate = useNavigate();
  var location = useLocation();
  var themeCtx = useTheme();
  var theme = themeCtx.theme;
  var toggleTheme = themeCtx.toggleTheme;
  var auth = useContext(AuthContext);

  // Detect if we're inside a site view
  var cleanPath = location.pathname.replace(process.env.PUBLIC_URL || '', '');
  var pathMatch = cleanPath.match(/\/sites\/(\d+)/);
  var currentSiteId = pathMatch ? pathMatch[1] : null;

  return (
    <div className="topbar">
      <div className="topbar-right">
        <div className="logo" onClick={function() { navigate('/'); }}>
          <div className="logo-mark">DA</div>
          <div className="logo-name">Daily AI <span>SEO & GEO</span></div>
        </div>
        {currentSiteId && (
          <>
            <div className="topbar-separator" />
            <SiteSwitcher currentSiteId={currentSiteId} />
          </>
        )}
      </div>
      <div className="topbar-left">
        <button className="topbar-btn" title={'הדוחות שלי'} onClick={function() { navigate("/reports"); }}
          style={Object.assign({ display: 'inline-flex', alignItems: 'center', gap: '6px', width: 'auto', padding: '0 12px' },
            cleanPath === "/reports" ? { background: "var(--accent-soft)", borderColor: "var(--accent)" } : {})}>
          <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.6" viewBox="0 0 24 24">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
            <path d="M14 2v6h6M9 13h6M9 17h4"/>
          </svg>
          <span style={{ fontSize: '13px', fontWeight: 500 }}>הדוחות שלי</span>
        </button>
        <button className="topbar-btn" title={'מדידת GEO — כל האתרים'} onClick={function() { navigate("/geo-measurement"); }}
          style={Object.assign({ display: 'inline-flex', alignItems: 'center', gap: '6px', width: 'auto', padding: '0 12px' },
            cleanPath === "/geo-measurement" ? { background: "var(--accent-soft)", borderColor: "var(--accent)" } : {})}>
          <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.6" viewBox="0 0 24 24">
            <path d="M3 17l5-7 4 4 5-8 4 6"/>
          </svg>
          <span style={{ fontSize: '13px', fontWeight: 500 }}>מדידת GEO</span>
        </button>
        <button className="topbar-btn" title={'זמינות אתרים'} onClick={function() { navigate("/uptime"); }}
          style={Object.assign({ display: 'inline-flex', alignItems: 'center', gap: '6px', width: 'auto', padding: '0 12px' },
            cleanPath === "/uptime" ? { background: "var(--accent-soft)", borderColor: "var(--accent)" } : {})}>
          <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.6" viewBox="0 0 24 24">
            <path d="M22 12h-4l-3 9L9 3l-3 9H2"/>
          </svg>
          <span style={{ fontSize: '13px', fontWeight: 500 }}>זמינות</span>
        </button>
        <button className="topbar-btn" title={'ניהול מערכת'} onClick={function() { navigate("/system"); }}
          style={location.pathname.includes("/system") ? { background: "var(--accent-soft)", borderColor: "var(--accent)" } : undefined}>
          <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.6" viewBox="0 0 24 24">
            <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/>
          </svg>
        </button>
        <button className="theme-toggle-btn" onClick={toggleTheme} title={theme === 'dark' ? '\u05de\u05e6\u05d1 \u05d1\u05d4\u05d9\u05e8' : '\u05de\u05e6\u05d1 \u05db\u05d4\u05d4'}>
          {theme === 'dark' ? (
            <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5">
              <circle cx="10" cy="10" r="4"/>
              <path d="M10 2v2m0 12v2m-6-8H2m16 0h-2m-1.2-4.8l-1.4 1.4M5.6 14.4l-1.4 1.4m0-9.6l1.4 1.4m9.6 7.2l1.4 1.4"/>
            </svg>
          ) : (
            <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5">
              <path d="M17.3 12.3A7 7 0 117.7 2.7 8 8 0 0017.3 12.3z"/>
            </svg>
          )}
        </button>
        <button className="topbar-btn" title={'\u05d4\u05ea\u05e8\u05d0\u05d5\u05ea'}>
          <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8">
            <path d="M9 16.5c.8 0 1.5-.7 1.5-1.5h-3c0 .8.7 1.5 1.5 1.5zM15 12V8c0-3-2-5.4-4.5-6V1.5a1.5 1.5 0 00-3 0V2C5 2.6 3 5 3 8v4l-1.5 1.5v.5h15v-.5L15 12z"/>
          </svg>
          <span className="notif-badge">3</span>
        </button>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          {auth && auth.user && (
            <span style={{ fontSize: '12px', color: 'var(--text-secondary)', fontWeight: 500 }}>
              {auth.user.name}
            </span>
          )}
          <div className="avatar" onClick={function() {
            if (auth && auth.logout && window.confirm('\u05dc\u05d4\u05ea\u05e0\u05ea\u05e7 \u05de\u05d4\u05de\u05e2\u05e8\u05db\u05ea?')) {
              auth.logout();
            }
          }} style={{ cursor: 'pointer' }} title={'\u05d4\u05ea\u05e0\u05ea\u05e7'}>
            {auth && auth.user ? auth.user.name.charAt(0) : 'DA'}
          </div>
        </div>
      </div>
    </div>
  );
}
